module.exports = __webpack_public_path__ + "Good.258257dc2d9c26a4c4c1.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Good.otf
// module id = 373
// module chunks = 8